var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 90,
    viewBox: "0 0 460 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0C59.2014 0 71.8663 6.57846 80.1136 16.8543C74.3804 24.7616 71 34.486 71 45C71 55.514 74.3804 65.2384 80.1136 73.1457C71.8663 83.4215 59.2014 90 45 90C20.1472 90 0 69.8528 0 45C0 20.1472 20.1472 0 45 0Z",
    fill: "#BFC2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 0C133.201 0 145.866 6.57846 154.114 16.8543C148.38 24.7616 145 34.486 145 45C145 55.514 148.38 65.2384 154.114 73.1457C145.866 83.4215 133.201 90 119 90C94.1472 90 74 69.8528 74 45C74 20.1472 94.1472 0 119 0Z",
    fill: "#BFC2ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193 0C207.201 0 219.866 6.57846 228.114 16.8543C222.38 24.7616 219 34.486 219 45C219 55.514 222.38 65.2384 228.114 73.1457C219.866 83.4215 207.201 90 193 90C168.147 90 148 69.8528 148 45C148 20.1472 168.147 0 193 0Z",
    fill: "#BFC2ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267 0C281.201 0 293.866 6.57846 302.114 16.8543C301.397 17.8427 300.717 18.8595 300.076 19.9027C295.588 27.2051 293 35.8003 293 45C293 55.514 296.38 65.2384 302.114 73.1457C301.083 74.4302 299.983 75.6569 298.819 76.8202C290.676 84.9634 279.426 90 267 90C242.147 90 222 69.8528 222 45C222 20.1472 242.147 0 267 0Z",
    fill: "#BFC2ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M376.114 16.8543C367.866 6.57846 355.201 0 341 0C316.147 0 296 20.1472 296 45C296 69.8528 316.147 90 341 90C355.201 90 367.866 83.4215 376.114 73.1457C370.38 65.2384 367 55.514 367 45C367 34.486 370.38 24.7616 376.114 16.8543Z",
    fill: "#BFC2ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M460 45C460 69.8528 439.853 90 415 90C390.147 90 370 69.8528 370 45C370 20.1472 390.147 0 415 0C439.853 0 460 20.1472 460 45Z",
    fill: "#BFC2ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialBack);
export default __webpack_public_path__ + "static/media/social_back.c80217628f965d970223c146de10b50d.svg";
export { ForwardRef as ReactComponent };